import React from 'react';
import { EditPage } from '@components/common';
import UserForm from '@components/common/forms/UserForm';

const UserEditPage = () => {
    const handleTransformData = (formData) => {
        // Transform form data for user update
        return {
            ...formData,
            updated_at: new Date().toISOString()
        };
    };

    const handleTransformFetchedData = (data) => {
        // Transform fetched data for form consumption
        return {
            ...data,
            // Any necessary data transformations for editing
        };
    };

    return (
        <EditPage
            modelName="users"
            FormComponent={UserForm}
            transformData={handleTransformData}
            transformFetchedData={handleTransformFetchedData}
            backPath="/admin/user-management"
            successPath="/admin/user-management"
            title="Edit User"
            subtitle="Modify user role and permissions"
        />
    );
};

export default UserEditPage;
